export const conciergeServices = [
  {
    title: "1 — Visite de contrôle de la résidence",
    tarif: "40 € la visite — jusqu'à 1 heure. Compte rendu et photos / vidéos inclus si souhaités.",
    description: "Par exemple : vous souhaitez simplement vous assurer régulièrement que tout va bien dans votre résidence principale ou secondaire, en votre absence ? Je peux effectuer des visites de contrôle et vous tenir informé de la situation sur place.",
    items: [
      "Faire le tour extérieur de la propriété",
      "Vérifier visuellement portes, fenêtres et volets",
      "Entrer dans la résidence et vérifier qu'aucune anomalie n'est visible",
      "Vérifier l'absence apparente de fuite d'eau",
      "Vérifier l'absence d'anomalie électrique évidente",
      "Aérer la résidence",
      "Ouvrir et refermer certains volets si demandé",
      "Relever le courrier",
      "Sortir et rentrer les poubelles si nécessaire",
      "Arroser les plantes",
      "Vérifier le réfrigérateur/congélateur si demandé",
      "Faire couler l'eau, ouvrir et fermer les robinets et tirer les chasses d'eau",
      "Prendre des photos si nécessaire",
      "Envoyer au propriétaire un compte rendu après le passage",
      "En cas d'anomalie constatée, prévenir le propriétaire"
    ]
  },
  {
    title: "2 — Préparation de votre résidence avant votre arrivée",
    tarif: "30 €/h — intervention minimale d'une heure, puis facturation par tranche de 30 minutes. Compte rendu et photos / vidéos inclus si souhaités.",
    description: "Par exemple : vous habitez à Paris et arrivez vendredi soir dans votre résidence secondaire en Finistère ? Je peux préparer la maison avant votre arrivée.",
    items: [
      "Aérer la maison",
      "Ouvrir les volets",
      "Remettre en fonctionnement certains équipements préalablement arrêtés",
      "Vérifier que l'eau et l'électricité fonctionnent normalement",
      "Mettre le chauffage en route ou ajuster la température si demandé",
      "Vérifier rapidement l'état général de la résidence",
      "Faire les lits et mettre du linge propre à disposition",
      "Effectuer un petit rangement si nécessaire",
      "Faire vos courses à partir de la liste que vous m'avez transmise",
      "Ranger les courses et mettre les boissons au frais",
      "Préparer quelques éléments simples selon vos demandes",
      "Arroser les plantes",
      "Sortir le mobilier de jardin facilement manipulable et préparer simplement la terrasse ou la table extérieure",
      "Réceptionner au préalable une commande ou une livraison",
      "Vérifier que les clés et accès sont prêts pour votre arrivée",
      "Vous envoyer un message lorsque votre résidence est prête"
    ],
    note: "Vous souhaitez une arrivée personnalisée ? Je peux également prévoir, à votre demande, des fleurs, des produits locaux, le nécessaire pour votre petit-déjeuner ou d'autres petites attentions. Les achats sont facturés en supplément, sur justificatif."
  },
  {
    title: "3 — Après votre départ",
    tarif: "30 €/h — intervention minimale d'une heure, puis facturation par tranche de 30 minutes. Compte rendu et photos / vidéos inclus si souhaités.",
    description: "Par exemple : votre séjour en Finistère est terminé et vous devez reprendre la route ou votre train sans avoir le temps de tout préparer avant votre départ ? Je peux prendre le relais une fois que vous êtes parti.",
    items: [
      "Aérer puis refermer la résidence",
      "Fermer les volets selon vos consignes",
      "Vérifier que portes et fenêtres sont correctement fermées",
      "Vérifier visuellement l'état général de la résidence",
      "Ranger les derniers éléments laissés sur place",
      "Faire la vaisselle ou vider le lave-vaisselle",
      "Retirer et rassembler le linge de lit et les serviettes utilisés",
      "Lancer une lessive, étendre, plier et ranger le linge si demandé",
      "Refaire les lits avec du linge propre si nécessaire",
      "Effectuer un entretien courant / ménage de la résidence",
      "Vider les poubelles et les sortir si nécessaire",
      "Vérifier le réfrigérateur et retirer les produits indiqués",
      "Ranger le mobilier extérieur facilement manipulable si demandé",
      "Arroser les plantes",
      "Mettre la résidence dans la configuration souhaitée pour votre absence : chauffage, eau et équipements, selon vos consignes",
      "Prendre des photos de la résidence après mon passage et vous les transmettre si vous le souhaitez",
      "Vous signaler toute anomalie constatée et vous transmettre des photos si nécessaire",
      "Vous envoyer un message lorsque tout est terminé"
    ]
  },
  {
    title: "4 — Vos animaux pendant votre absence",
    tarif: "20 €/h — intervention minimale d'une heure, puis facturation par tranche de 30 minutes. Compte rendu et photos / vidéos inclus si souhaités.",
    description: "Par exemple : vous partez quelques jours et votre chat reste tranquillement dans son environnement habituel ? Vous avez des poissons ou d'autres petits animaux dont les besoins sont compatibles avec des visites à domicile ? Je peux également prendre soin d'eux pendant votre absence.",
    items: [
      "Nourrir votre animal selon vos consignes",
      "Renouveler son eau fraîche",
      "Nettoyer et changer la litière du chat",
      "Nettoyer les gamelles et maintenir propre son espace habituel",
      "Passer un moment avec lui et lui apporter une présence",
      "S'occuper des poissons : nourriture et vérification visuelle simple de l'aquarium",
      "Acheter ou récupérer de la nourriture ou des fournitures si nécessaire",
      "Récupérer un traitement déjà préparé chez le vétérinaire",
      "Accompagner l'animal chez le vétérinaire si nécessaire",
      "Respecter ses habitudes et les consignes laissées par son propriétaire",
      "Vous envoyer des nouvelles et des photos après mon passage si vous le souhaitez",
      "Vous prévenir si je constate un comportement ou une situation inhabituelle"
    ],
    note: "Ce service concerne les animaux dont les besoins sont compatibles avec des visites à domicile pendant l'absence de leur propriétaire."
  },
  {
    title: "5 — Artisans, techniciens et livraisons",
    tarif: "30 €/h — intervention minimale d'une heure, puis facturation par tranche de 30 minutes. Compte rendu et photos / vidéos inclus si souhaités.",
    description: "Par exemple : vous vivez à Paris et un plombier doit intervenir mardi matin dans votre résidence secondaire en Finistère ? Inutile de faire plusieurs centaines de kilomètres uniquement pour lui ouvrir la porte. Je peux être présente sur place à votre place.",
    items: [
      "Être présente au domicile à l'heure convenue",
      "Accueillir l'artisan, le technicien ou le livreur, lui donner accès aux espaces concernés et lui transmettre vos consignes",
      "Être présente pendant tout ou partie de son intervention, selon votre demande",
      "Réceptionner une livraison",
      "Vérifier visuellement l'état apparent d'un colis ou d'une livraison à son arrivée",
      "Vous prévenir si je constate une anomalie évidente",
      "Prendre des photos avant ou après l'intervention si vous le souhaitez",
      "Vous transmettre un compte rendu de mon passage",
      "Après son départ, vérifier et refermer correctement la résidence selon vos consignes"
    ]
  },
  {
    title: "6 — Intendance de votre location saisonnière",
    tarif: "30 €/h — intervention minimale d'une heure, puis facturation par tranche de 30 minutes. Compte rendu et photos / vidéos inclus si souhaités.",
    description: "Par exemple : vous proposez votre résidence en location saisonnière mais vous n'habitez pas à proximité ? Je peux être votre relais sur place entre deux locations et lors de l'arrivée ou du départ de vos voyageurs.",
    items: [
      "Vérifier visuellement le logement avant l'arrivée des voyageurs",
      "Aérer le logement",
      "Ouvrir les volets et préparer la résidence",
      "Vérifier que le logement est propre et prêt à accueillir les voyageurs",
      "Préparer les lits et mettre le linge à disposition",
      "Vérifier la présence des éléments prévus pour l'accueil",
      "Préparer une petite attention d'accueil si vous le souhaitez",
      "Accueillir les voyageurs sur place",
      "Remettre les clés et présenter le logement",
      "Transmettre les informations pratiques que vous aurez préalablement définies",
      "Récupérer les clés au départ si nécessaire",
      "Effectuer un contrôle visuel du logement après le départ",
      "Signaler rapidement toute anomalie ou dégradation apparente",
      "Prendre et transmettre des photos si nécessaire",
      "Vérifier que portes et fenêtres sont correctement fermées",
      "Vérifier certains objets ou équipements selon une liste définie ensemble",
      "Effectuer le ménage entre deux locations",
      "Gérer le linge : retrait, lavage, séchage, pliage et remise en place",
      "Sortir les poubelles",
      "Réapprovisionner les produits d'accueil ou consommables selon vos consignes",
      "Réceptionner une livraison destinée au logement",
      "Être présente lors du passage d'un artisan ou d'un technicien si nécessaire",
      "Vous transmettre un compte rendu après mon intervention, si vous le souhaitez"
    ],
    note: "Le propriétaire conserve la gestion de son annonce, de ses réservations et de ses échanges avec les voyageurs. Mon rôle est d'être votre relais de confiance sur place pour tout ce qui nécessite une présence physique."
  },
  {
    title: "7 — Un imprévu pendant votre absence ?",
    tarif: "30 €/h — intervention minimale d'une heure, puis facturation par tranche de 30 minutes. Compte rendu et photos / vidéos inclus si souhaités.",
    description: "Par exemple : vous êtes à plusieurs centaines de kilomètres et un voisin vous prévient qu'une tuile semble avoir bougé après une tempête, qu'une fenêtre est restée ouverte ou qu'un problème pourrait être survenu dans votre résidence ? Je peux me rendre sur place pour effectuer une première vérification visuelle et vous informer de la situation.",
    items: [
      "Me rendre à la résidence à votre demande",
      "Effectuer une vérification visuelle intérieure et/ou extérieure",
      "Prendre des photos et vous les transmettre",
      "Vous appeler ou vous envoyer un compte rendu de ce que j'ai constaté",
      "Fermer une porte, une fenêtre ou des volets lorsque cela peut être fait simplement et sans danger",
      "Mettre à l'abri de petits objets extérieurs facilement manipulables",
      "Vérifier visuellement la présence éventuelle d'eau ou d'une anomalie apparente",
      "Être présente si vous faites intervenir ensuite un professionnel",
      "Lui ouvrir la résidence et lui transmettre vos consignes",
      "Vous tenir informé de son passage"
    ],
    afterNote: `Mon intervention consiste à constater la situation sur place et à vous en informer. Toute intervention technique nécessitant un professionnel est réalisée par le professionnel compétent, avec votre accord. Les interventions liées à un imprévu sont réalisées selon mes disponibilités et ne constituent pas un service d'urgence.

Soit vous disposez déjà de votre artisan ou technicien ; dans ce cas, je prends le relais sur place pour permettre son intervention. Soit vous souhaitez que je recherche et prenne contact avec le professionnel dont vous avez besoin. Dans ce cas, le temps consacré à cette recherche est facturé sur la même base de 30 €/h, avec une intervention minimale d'1 heure, puis facturation par tranche de 30 minutes.`
  },
  {
    title: "Temps de prestation et déplacements",
    description: `Le temps de prestation est décompté à partir de mon heure d'arrivée sur le lieu d'intervention et jusqu'à la fin de la prestation.
Le temps passé sur la route n'est pas facturé.

Les déplacements sont inclus dans un rayon de 15 km autour de Guipavas, point de départ des déplacements. Au-delà, seuls les kilomètres supplémentaires parcourus, aller-retour, sont facturés 0,50 €/km.

Exemple : votre résidence se situe à 30 km de Guipavas. Les 15 premiers kilomètres sont inclus. Les 15 km supplémentaires sont facturés à l'aller et au retour, soit 30 km × 0,50 € = 12 € de frais de déplacement. Le temps passé sur la route reste, lui, non facturé.`,
    items: [],
    note: "Prestations proposées : du lundi au samedi.\nJours fériés : majoration de 50 % sur le tarif habituel.\nAchats et dépenses : les achats effectués à votre demande sont facturés en supplément, sur justificatif."
  }
];